export const personal_policy = `
<h1>개인정보처리방침</h1>
<p style="margin-top: 15px">
'퍼스널뉴스서비스'(이하 ‘회사’라 함)는 고객님의 정보를 중요하게 생각하며 아래와 같은 개인정보처리방침을 가지고 있습니다. 
회사는 “정보통신망 이용촉진 및 정보보호 등에 관한 법률”을 준수하며 고객님의 정보가 어떤 용도와 방식으로 사용되고 있으며 
개인정보보호를 위해 어떤 조치를 취하고 있는지 알려드립니다.
</p>
<h3 style="margin-top: 15px">1조 수집하는 개인정보 항목 및 수집방법</h3>
<h3>2조 개인정보의 수집 및 이용목적</h3>
<h3>3조 개인정보 수집에 대한 동의</h3>
<h3>4조 개인정보의 이용 현황</h3>
<h3>5조 개인정보의 제3자 제공 및 처리 위탁 현황</h3>
<h3>6조 개인정보의 보유 및 이용기간</h3>
<h3>7조 개인정보의 파기절차 및 방법</h3>
<h3>8조 이용자 및 법정대리인의 권리와 그 행사방법</h3>
<h3>9조 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항</h3>
<h3>10조 개인정보보호를 위한 기술적, 관리적 대책</h3>
<h3>11조 아동의 개인정보</h3>
<h3>12조 개인정보 보호책임자</h3>
<h3>13조 부칙</h3>

<h2 style="margin-top: 15px">제 1 조 수집하는 개인정보 항목 및 수집방법 </h2>
<p >회사는 회원 가입, 서비스제공, 기타상담 등을 위해 개인정보를 수집하고 있으며,
    또한 설문조사나 이벤트 시에 집단적인 통계분석을 위해서나 경품발송을 위한 목적으로도 개인정보 기재를 요청할 수 있습니다.
    그러나, 회사는 이용자의 기본적 인권 침해의 우려가 있는 민감한 개인정보 (인종 및 민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향 및 범죄기록 등)는
    가급적 수집하지 않으며 부득이하게 수집해야 할 경우 이용자들의 사전동의를 반드시 구합니다.
    이때에도 기입하신 정보는 해당서비스 제공이나 회원님께 사전에 밝힌 목적 이외의 다른 어떠한 목적으로도 사용되지 않음을 알려드립니다.</p>
<p>개인정보의 수집 내용은 아래와 같습니다.</p>
<p><strong>필수항목: </strong>&nbsp;&nbsp;&nbsp;&nbsp;개인회원: 이름, e-mail, 휴대폰, 로그인 password</p>
<p><strong>선택항목: </strong>&nbsp;&nbsp;&nbsp;&nbsp;신용카드정보, 은행계좌정보 등 대금결제에 필요한 정보</p>
<p><strong>개인정보수집방법: </strong>&nbsp;&nbsp;&nbsp;&nbsp;홈페이지</p>

<h2 style="margin-top: 15px">제 2 조 개인정보의 수집 및 이용목적</h2>
<p>회사는 아래와 같은 목적으로 개인정보를 수집합니다.</p>
<ul>
    <li>서비스 제공에 관한 계약이행 및 서비스제공에 따른 요금정산</li>
    <li>컨텐츠 제공, 청구서 발송, 본인인증, 구매 및 요금결제, 금융서비스</li>
    <li>회원관리</li>
    <li>회원제 서비스 이용에 따른 본인 확인, 개인식별, 불량회원의 부정 이용 방지와 비인가 사용방지, 가입 의사 및 연령 확인, 만 14세 미만 아동의 개인정보 수집 시 법정 대리인 동의여부 확인, 불만처리 등 민원처리, 고지사항 전달.</li>
    <li>서비스 안내 및 마케팅</li>
    <li>신규 서비스 개발 및 특화, 인구통계학적 특성에 따른 서비스 제공 및 광고게재, 접속 빈도 파악, 회원의 서비스 이용에 대한 통계, 이벤트 등 광고성 정보 전달</li>
</ul>

<h2 style="margin-top: 15px">제 3 조 개인정보 수집에 대한 동의</h2>
<p>회사는 회원님의 개인정보 수집에 대하여 동의를 받고 있으며, 회사 내의 회원가입 절차 중 이용약관 및 개인정보처리방침에 개인정보 수집 동의절차를 마련해 두고 있습니다. 회원님께서 [서비스 이용약관 동의]란에 체크하시면 개인정보 수집에 대해 동의한 것으로 봅니다.</p>

<h2 style="margin-top: 15px">제 4 조 개인정보의 이용 현황</h2>
<p>회사는 이용자들의 개인정보를 ‘2. 개인정보의 수집 및 이용목적’에서 고지한 범위내에서 사용하며, 이용자의 사전 동의 없이는 동 범위를 초과하여 이용하거나 원칙적으로 이용자의 개인정보를 외부에 공개하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.</p>
<ol>
    <li>이용자들이 사전에 공개에 동의한 경우</li>
    <li>법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</li>
</ol>

<h2 style="margin-top: 15px">제 5 조 개인정보의 제3자 제공 및 처리 위탁 현황</h2>
<p>개인정보 제3자 제공 회사는 고객님의 동의없이 고객님의 정보를 제3자에게 제공하지 않습니다.
    향후 그러한 필요가 생길 경우, 고객님에게 통지하고 필요한 경우 사전 동의를 받도록 하겠습니다.</p>

<h2 style="margin-top: 15px">제 6 조 개인정보의 보유 및 이용 기간</h2>
<p>서비스 이용자가 당사의 회원으로서 서비스를 계속 이용하는 동안 당사는 이용자의 개인정보를 계속 보유하며 서비스 제공 등을 위해 이용합니다.</p>
   <p> 서비스 이용자의 개인정보는 그 수집 및 이용 목적(설문조사, 이벤트 등 일시적인 목적을 포함)이 달성되거나
    이용자가 직접 삭제 또는 회원 탈퇴한 경우에 재생할 수 없는 방법으로 파기합니다.</p>
  <p>  당사는 이용자의 권리 남용, 악용 방지, 권리침해/명예훼손 분쟁 및 수사협조 등의 요청이 있었을 경우에는
    이의 재발에 대비하여 회원의 이용계약 해지 시로부터 1년 동안 회원의 개인정보를 보관할 수 있습니다. </p>
<p>상법, 전자상거래 등에서의 소비자보호에 관한 법률 등 관계법령의 규정에 의하여 보존할 필요가 있는 경우
    당사는 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다.
    이 경우 당사는 보관하는 정보를 그 보관의 목적으로만 이용하며 보존기간은 아래와 같습니다.</p>
<p><strong>회사 내부 방침에 의한 정보보유 사유</strong></p>
<p>회원탈퇴 시 개인정보 보존기간은 아래와 같습니다.</p>
<ul>
    <li>보존근거: 불량 이용자의 재가입 방지, 명예훼손 등 권리침해 분쟁 및 수사협조</li>
    <li>보존기간: 회원탈퇴 후 1년</li>
</ul>
<p><strong>관련법령에 의한 정보보유 사유</strong></p>
<p>상법, 전자상거래 등에서의 소비자보호에 관한 법률 등 관계법령의 규정에 의하여 보존할 필요가 있는 경우
    회사는 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다.
    이 경우 회사는 보관하는 정보를 그 보관의 목적으로만 이용하며 보존기간은 아래와 같습니다.</p>
<ol>
    <li>계약 또는 청약철회 등에 관한 기록</li>
    <p>보존 이유 및 기간: 전자상거래 등에서의 소비자보호에 관한 법률 (5년)</p>
    <li>대금결제 및 재화 등의 공급에 관한 기록</li>
    <p>보존 이유 및 기간: 전자상거래 등에서의 소비자보호에 관한 법률 (5년)</p>
    <li>소비자의 불만 또는 분쟁처리에 관한 기록</li>
    <p>보존 이유 및 기간: 전자상거래 등에서의 소비자보호에 관한 법률 (3년)</p>
    <li>본인확인에 관한 기록</li>
    <p>보존 이유 및 기간: 정보통신망 이용촉진 및 정보보호 등에 관한 법률 (6개월)</p>
    <li>방문에 관한 기록</li>
    <p>보존 이유 및 기간: 정보통신망 이용촉진 및 정보보호 등에 관한 법률 (3개월)</p>
</ol>

<h2 style="margin-top: 15px">제 7 조 개인정보의 파기절차 및 방법</h2>
<p>회원님은 언제든지 등록되어 있는 회원님의 개인 정보를 열람하거나 정정하실 수 있으며, 회원 탈퇴를 요청하실 수 있습니다.
    회원님의 개인 정보 열람 및 수정은 사이트 내의 회원정보 변경을 통해 로그인(Log-in) 후 가능하며, 아이디, 이름을 제외한 사항은 수정 가능합니다.
    회원 탈퇴를 원하실 경우 사이트 내에서 탈퇴가 가능하며, 등록된 모든 정보를 파기함으로 탈퇴 여부를 신중히 고려하셔야 합니다.
    또한 탈퇴 후 재가입에 제약이 따를 수도 있습니다.</p>
<p>회사의 개인정보 파기절차 및 방법은 다음과 같습니다.</p>
<p><strong>파기절차</strong></p>
<ul>
    <li>이용자가 회원가입 등을 위해 입력한 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함)
        내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기됩니다.</li>
    <li>동 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.</li>
</ul>
<p><strong>파기방법</strong></p>
<ul>
    <li>종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.</li>
    <li>전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.</li>
</ul>

<h2 style="margin-top: 15px">제 9 조 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항</h2>
<p>쿠키(cookie)는 HTTP 서버에서 사용자 브라우저에게 보내는 조그마한 데이터 파일로써 회원님의 컴퓨터에 저장됩니다.
    회사는 이러한 쿠키(cookie)를 이용하여 회원님의 브라우저 형식이나 서비스 이용 형태를 얻게 되며, 이러한 쿠키 정보를 바탕으로
    회원님께 유용하고 보다 편리한 맞춤서비스를 제공하는데 사용하게 됩니다.</p>
<p>회원님은 쿠키에 대한 선택권을 가지고 있습니다.
    회원님의 웹브라우저에서 옵션을 선택함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다.
    단, 쿠키의 저장을 거부하실 경우 로그인 (Log-in) 이 필요한 회사의 모든 서비스는 이용하실 수 없게 됩니다.</p>

<h2 style="margin-top: 15px">제 10 조 개인정보보호를 위한 기술적, 관리적 대책</h2>
<p>회원님의 개인정보는 비밀번호에 의해 보호되고 있습니다.
    회원님 계정의 비밀번호는 오직 본인만이 알 수 있으며, 개인정보의 확인 및 변경도 비밀번호를 알고 있는 본인에 의해서만 가능합니다.
    따라서 회원님의 비밀번호는 누구에게도 알려주면 안됩니다.
    또한 작업을 마치신 후에는 로그아웃(log-out)하시고 웹브라우저를 종료하는 것이 바람직합니다.
    특히 다른 사람과 컴퓨터를 공유하여 사용하거나 공공장소에서 이용한 경우 개인정보가 다른 사람에게 알려지는 것을 막기 위해서 이와 같은 절차가 더욱 필요합니다.
    이용자 부주의나 인터넷상의 문제로 인한 개인정보 유출에 대해서 회사는 책임을 지지 않습니다.</p>
<p>회사는 개인정보보호를 위한 기술적 관리적 대책을 다음과 같이 시행하고 있습니다.</p>
<ol>
    <li>해킹 방지를 위한 방화벽과 보안시스템에 만전을 기하고 있습니다.</li>
    <li>개인정보 송수신시 SSL 보안서버 인증서를 설치하여 정보를 보호합니다.</li>
    <li>개인정보의 접근은 해당 업무 수행자, 업무 수행 시 개인정보가 필요한 업무자만 가능하도록 접근 권한을 제한하고 있으며, 업무용 PC에 대한 접근 및 이용권한을 업무 담당자 별로 부여하여 이용자의 개인정보를 보호하고 있습니다.</li>
    <li>이용자의 개인정보가 누출되지 않도록 암호화 통신 등을 이용하여 네트워크 상에서 개인정보를 안전하게 송수신 할 수 있도록 하고 있습니다.</li>
    <li>개인정보를 처리하는 직원을 대상으로 개인정보보호에 대한 교육을 수시로 실시하고 있으며, 개인정보보호 의무를 강조하고 있습니다.</li>
    <li>개인정보보호 책임자는 개인정보 관련 지침의 준수사항 및 당사의 지속적인 개인정보 보호 프로그램의 이행 및 감독을 총괄하며, 개인정보 관련 민원 처리 및 피해구제 등을 위해 항상 준비하고 있습니다.</li>
</ol>

<h2 style="margin-top: 15px">제 12 조 개인정보 보호책임자</h2>
<p>회사 개인정보처리방침과 관련하여 의견이 있을 경우 메일을 주시면 접수 즉시 조치하고 처리결과를 알려드리겠습니다. 개인정보 보호책임자는 아래와 같습니다. </p>
<p>개인정보보호책임자</p>
<ul>
    <li>책임자: 박석준</li>
    <li>전화번호: 031-8039-7035</li>
    <li>E-mai: sjpark@2digit.io</li>
</ul>
<p>기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.</p>
<ul>
    <li>개인정보침해신고센터 : privacy.kisa.or.kr / 국번없이 118 </li>
    <li>대검찰청 사이버범죄수사단 : www.spo.go.kr / 국번없이 1301</li>
    <li>경찰청 사이버테러대응센터 : cyberbureau.police.go.kr / 국번없이 182</li>
</ul>
<h2 style="margin-top: 15px">제 13 조 부칙</h2>
<p>현 개인정보처리방침의 수정, 변경이 있을 시 최소 7일 이전에 사이트 내 공지를 통하여 고지할 것입니다. </p>
<p> - 개인정보처리방침 시행일자 : 2023-09-14</p>`
